import { render, staticRenderFns } from "./ItemsGrid.vue?vue&type=template&id=7f2119fa&scoped=true&"
import script from "./ItemsGrid.vue?vue&type=script&lang=js&"
export * from "./ItemsGrid.vue?vue&type=script&lang=js&"
import style0 from "./ItemsGrid.vue?vue&type=style&index=0&id=7f2119fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2119fa",
  null
  
)

export default component.exports